// React 19 ignores defaultProps on function components. This applies them the way
// React did: a default fills a prop only when the prop is undefined.
export default function withDefaultProps(props, defaults) {
	let merged = props;
	for(const key of Object.keys(defaults)) {
		if(props[key] === undefined) {
			if(merged === props) {
				merged = { ...props };
			}
			merged[key] = defaults[key];
		}
	}
	return merged;
}
